import React, { useCallback, useMemo } from "react";
import styles from "./HomeContainer.module.scss";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import LeftNavigation from "../../common/views/LeftNavigation";
import { useSelector } from "react-redux";
import DashboardToolbar from "../../components/DashboardToolbar";
import { useHistory } from "react-router-dom";
import { routeFormatter } from "../../utils/Formatter";
import { ROUTES } from "../../utils/Constant";
import { useTeamFetcher } from "../../utils/TeamsFetcherHooks";
import TeamService from "../../service/TeamService";
import UtilityButton from "../../components/UtilityButton";
import SupportBox from "../../components/SupportBox";
import plusIcon from "../../assets/editor/plus_icon.svg";
import wavingHand from "../../assets/editor/wavingHand.svg";
import sparkling from "../../assets/editor/sparkling.svg";
import checkBadge from "../../assets/editor/checkBadge.svg";

const HomeContainer = (props) => {
  const { t } = useTranslation();

  const history = useHistory();

  const userInfos = useSelector((state) => state.userInfo);
  const teamsState = useSelector((state) => state.myTeams);
  const teams = useMemo(() => {
    return teamsState?.teams;
  }, [teamsState]);

  const { fetchMyTeamsAndUpdateStore } = useTeamFetcher();

  const onNewTeamClick = useCallback(async () => {
    const bodyData = {
      name: `${t("team.team")} ${teams.length + 1}`,
    };

    const {
      data: {
        data: { id },
      },
    } = await TeamService.createTeam(bodyData);

    fetchMyTeamsAndUpdateStore();

    history.push(routeFormatter(ROUTES.TEAM_PROJECTS, { params: { id: id } }));
  }, [history, t, teams, fetchMyTeamsAndUpdateStore]);

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{`${t("pages.home.title")}`}</title>
      </Helmet>
      <DashboardToolbar />
      <div className={styles.dashboardContainer}>
        <LeftNavigation />
        <div className={styles.centerContainer}>
          <h3 className={styles.title}>
            {t("HomePage.Welcome", {
              first_name: userInfos?.firstName,
              last_name: userInfos?.lastName,
            })}
          </h3>
          <div className={styles.utilityButtonContainer}>
            <UtilityButton
              text={t("HomePage.NewTeam.New_Team")}
              subtext={t("HomePage.NewTeam.Get_Started")}
              icon={plusIcon}
              onClick={onNewTeamClick}
            ></UtilityButton>
          </div>

          <div className={styles.supportContainer}>
            <SupportBox
              text={t("HomePage.support.Title")}
              subtext={t("HomePage.support.Body")}
              linkText={t("HomePage.support.Redirect")}
              icon={wavingHand}
              backgroundColor={"#FBF8EA"}
              href="mailto:service@jameo.com"
            ></SupportBox>
            <SupportBox
              text={t("HomePage.Design.Title")}
              subtext={t("HomePage.Design.Body")}
              linkText={t("HomePage.Design.Redirect")}
              icon={sparkling}
              backgroundColor={"#E4F0E1"}
              href={t("HomePage.Designer_Link")}
            ></SupportBox>
            <SupportBox
              text={t("HomePage.Sales.Title")}
              subtext={t("HomePage.Sales.Body")}
              linkText={t("HomePage.Sales.Redirect")}
              icon={checkBadge}
              backgroundColor={"#B8D8EB"}
              href="mailto:info@jameo.com"
            ></SupportBox>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeContainer;
